import React from "react";
import cn from "classnames";
import { useHistory } from "react-router";
import Card from "../../../components/Card";
import Tabs from "../../../components/Tabs";
import styles from "./NFT.module.sass";
import ExperienceComponent from "./experience";

const MockLink =
	"https://media.istockphoto.com/id/1303761470/photo/suspicious-woman-checking-laptop-content-in-the-night.jpg?b=1&s=170667a&w=0&k=20&c=MFhQoVlBVWYaRQ0ORDaGOinZXuZtlVedxomRotJDbkI=";

const NFT = ({ data, refresh }) => {
	return (
		<Card title="NFT" classTitle="title-green">
			<div className={styles.container}>
				<div className={styles.top}>
					<div className={styles.img}>
						<img src={data.nftId?.image || MockLink} alt={data.name} />
					</div>
					<Top
						data={{
							owner: {
								_id: data?.nftOwner?._id,
								userName: data?.nftOwner?.userName,
							},
							...data.nftId,
						}}
					/>
				</div>
				<Tabs
					default_={0}
					head={["Experience"]}
					body={[
						// <Activity item={data} />,
						<ExperienceComponent data={data} refresh={refresh} />,
					]}
				/>
			</div>
		</Card>
	);
};

const Top = ({ data }) => {
	const history = useHistory();
	return (
		<div className={styles.topLeft}>
			<div className={styles.title}>
				<div className="title">Token ID - #{data.tokenId}</div>
				<div
					className={styles.pointer}
					onClick={() => {
						history.push(`/customers/list/customer/` + data?.owner?._id);
					}}
				>
					Owner: {data?.owner?.userName}
				</div>
			</div>
			<div className={styles.title}>
				<div className="title">{data.name}</div>
			</div>
			<div className={styles.statistic}>
				<div className={cn(styles.opacity, styles.cell)}>Price</div>
				<div className={cn(styles.opacity, styles.cell)}>Status</div>
				<div className={styles.cell}>
					{data.secondaryPrice} {data.currency}
				</div>
				<div className={styles.cell}>{data.status}</div>
			</div>
		</div>
	);
};

export default NFT;
